import Header from "components/header";
import LoginButtons from "components/login-buttons";
import Headroom from "react-headroom";
import LoadingSpinner from "components/loading-spinner.tsx";
import ContestSelector from "./contest-selector";
import useContestData from "hooks/useContestData";
import PartnerGameCarousel from "home/partner-game-carousel";
import UsernamePrompt from "home/username-form/username-prompt";

const ContestHome = () => {
  const { loading } = useContestData();

  return (
    <>
      <Headroom>
        <Header />
        <LoginButtons />
      </Headroom>
      <PartnerGameCarousel />
      <div style={{ display: "flex", flexDirection: "column" }}>
        {loading
          ? <LoadingSpinner/>
          : <ContestSelector />}
      </div>
      <UsernamePrompt />
    </>
  );
}

export default ContestHome;